export default [
    {
        title: 'House',
        icon: 'HomeIcon',
        tagVariant: 'light-warning',
        resource: 'Property',
        action: 'read',
        children: [
            {
                title: 'Lists',
                route: 'house-list',
                resource: 'House',
                action: 'read',
            },
            {
                title: 'Add',
                route: 'house-create',
                resource: 'House',
                action: 'create',
            },
            // {
            //     title: 'Request List',
            //     route: 'property-request-lists',
            //     resource: 'Property',
            //     action: 'read',
            // },
        ],
    },
]